'use client'

import { Phone, Mail, MapPin } from 'lucide-react'

// Mock data object
const contactInfo = {
  phone: "07562-292337",
  email: "prinwpoly.seh@mp.gov.in",
  location: "Government Women's Polytechnic College Sehore",
  title: "Let Us Know How We Can Help You",
  subtitle: "Drop us a line and let's talk."
}

export default function ContactUs() {
  const handleSubmit = (e) => {
    e.preventDefault()
    // Handle form submission
  }

  return (
    <div className="min-h-screen bg-gray-100 p-6 md:p-12">
      {/* Main Content */}
      <div className="container mx-auto px-4 py-8">
        {/* Title Section */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-teal-500 mb-2">{contactInfo.title}</h2>
          <p className="text-base md:text-lg text-gray-600">{contactInfo.subtitle}</p>
        </div>

        {/* Contact Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <div className="p-4 md:p-6 flex items-center space-x-4 border-4 border-teal-500 rounded-lg">
            <div className="bg-teal-500 p-3 rounded-full">
              <Phone className="h-6 w-6 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-sm md:text-base">Phone Number</h3>
              <a href={`tel:${contactInfo.phone}`} className="text-sm md:text-base text-gray-600 hover:text-teal-500">
                {contactInfo.phone}
              </a>
            </div>
          </div>

          <div className="p-4 md:p-6 flex items-center space-x-4 border-4 border-teal-500 rounded-lg">
            <div className="bg-teal-500 p-3 rounded-full">
              <Mail className="h-6 w-6 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-sm md:text-base">Any Question? Email us</h3>
              <a href={`mailto:${contactInfo.email}`} className="text-sm md:text-base text-gray-600 hover:text-teal-500">
                {contactInfo.email}
              </a>
            </div>
          </div>

          <div className="p-4 md:p-6 flex items-center space-x-4 border-4 border-teal-500 rounded-lg">
            <div className="bg-teal-500 p-3 rounded-full">
              <MapPin className="h-6 w-6 text-white" />
            </div>
            <div>
              <h3 className="font-semibold text-sm md:text-base">Our Location</h3>
              <a
                href={`https://www.google.com/maps?q=${contactInfo.location}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm md:text-base text-gray-600 hover:text-teal-500"
              >
                {contactInfo.location}
              </a>
            </div>
          </div>
        </div>

        {/* Map and Form Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Map */}
          <div className="w-full h-[300px] md:h-[400px] bg-gray-200 rounded-lg">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3667.0062161479796!2d77.09685767531936!3d23.20644407904528!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397c6774cdc8c20d%3A0xa1c0196c0123bda3!2sGOVT.WOMENS%20POLYTECHNIC%20COLLEGE%20SEHORE!5e0!3m2!1sen!2sin!4v1732602424434!5m2!1sen!2sin"
              width="100%"
              height="100%"
              className="border-4 border-teal-500 rounded-lg"
              loading="lazy"
            ></iframe>
          </div>

          {/* Form */}
          <div>
            <div className="p-6 border-4 border-teal-500 rounded-lg">
              <h3 className="text-lg md:text-xl font-semibold mb-4 md:mb-6">Need Some Advice?</h3>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <label htmlFor="firstName" className="text-sm font-medium">
                      First Name
                    </label>
                    <input
                      id="firstName"
                      placeholder="First Name"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                    />
                  </div>
                  <div className="space-y-2">
                    <label htmlFor="lastName" className="text-sm font-medium">
                      Last Name
                    </label>
                    <input
                      id="lastName"
                      placeholder="Last Name"
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                    />
                  </div>
                </div>
                <div className="space-y-2">
                  <label htmlFor="email" className="text-sm font-medium">
                    Email Address
                  </label>
                  <input
                    id="email"
                    type="email"
                    placeholder="Email Address"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                  />
                </div>
                <div className="space-y-2">
                  <label htmlFor="phone" className="text-sm font-medium">
                    Phone
                  </label>
                  <input
                    id="phone"
                    type="tel"
                    placeholder="Phone"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                  />
                </div>
                <div className="space-y-2">
                  <label htmlFor="message" className="text-sm font-medium">
                    Message
                  </label>
                  <textarea
                    id="message"
                    placeholder="Enter your message"
                    rows={4}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="w-full bg-teal-500 hover:bg-teal-600 text-white py-2 rounded-lg"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
